import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { RaindanceExportConfiguration } from '../../model/company';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';
import { SelectionItem } from '../../../core/component/select/select.component';
import { createDimensionSelection } from '../../../accounting/model/const/enum';

@Component({
    selector: 'app-company-raindance-config',
    templateUrl: './company-raindance-config.component.html',
    styleUrls: ['./company-raindance-config.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CompanyRaindanceConfigComponent implements OnInit {
  constructor(private _cf: FormControlExFactory) {}

  @Input() dataContext: RaindanceExportConfiguration;
  private _form: FormGroup;
  @Input() set form(value: AbstractControl) {
    this._form = value as FormGroup;
  }
  get form(): FormGroup {
    return this._form;
  }

  @Input() dimensionSelection: SelectionItem[] = createDimensionSelection(undefined, true);

  encodingSelection: SelectionItem[] = [
    new SelectionItem('ISO 8859-1 (CP-819)', 'CP-819'),
    new SelectionItem('UTF-8', 'UTF-8'),
    new SelectionItem('CP-1252', 'CP-1252'),
    new SelectionItem('UTF-8 BOM', 'UTF-8 BOM'),
    new SelectionItem('CP-437', 'CP-437'),
  ];

  ngOnInit(): void {
    if (this.form.contains('ansv')) return;

    this.form.addControl('fileExtension', this._cf.create('COMMON.FILE_EXTENSION', this.dataContext.fileExtension));
    this.form.addControl('encodingName', this._cf.create('COMPANY.SETTINGS_RAINDANCE_FIELDS.ENCODING', this.dataContext.encodingName));
    this.form.addControl('bundleFile', this._cf.create('COMPANY.SETTINGS_GL07_FIELDS.BUNDLE_FILE', this.dataContext.bundleFile));
    this.form.addControl(
      'asymmetricBundling',
      this._cf.create(
        'COMPANY.SETTINGS_GL07_FIELDS.ASYMMETRIC_BUNDLING',
        this.dataContext.asymmetricBundling,
        null,
        null,
        'COMPANY.SETTINGS_GL07_FIELDS.HELP_TEXT.ASYMMETRIC_BUNDLING'
      )
    );
    this.form.addControl(
      'includeTodaysWork',
      this._cf.create(
        'COMPANY.SETTINGS_GL07_FIELDS.INCLUDE_TODAYS_WORK',
        this.dataContext.includeTodaysWork,
        null,
        null,
        'COMPANY.SETTINGS_GL07_FIELDS.HELP_TEXT.INCLUDE_TODAYS_WORK'
      )
    );

    this.addDimensionControl('ansv', 'ansvFixed', 'COMPANY.SETTINGS_RAINDANCE_FIELDS.ANSV', this.dataContext.ansv, this.dataContext.ansvFixed);
    this.addDimensionControl('vht', 'vhtFixed', 'COMPANY.SETTINGS_RAINDANCE_FIELDS.VHT', this.dataContext.vht, this.dataContext.vhtFixed);
    this.addDimensionControl('akt', 'aktFixed', 'COMPANY.SETTINGS_RAINDANCE_FIELDS.AKT', this.dataContext.akt, this.dataContext.aktFixed);
    this.addDimensionControl('obj', 'objFixed', 'COMPANY.SETTINGS_RAINDANCE_FIELDS.OBJ', this.dataContext.obj, this.dataContext.objFixed);
    this.addDimensionControl('proj', 'projFixed', 'COMPANY.SETTINGS_RAINDANCE_FIELDS.PROJ', this.dataContext.proj, this.dataContext.projFixed);
    this.addDimensionControl('mk', 'mkFixed', 'COMPANY.SETTINGS_RAINDANCE_FIELDS.MK', this.dataContext.mk, this.dataContext.mkFixed);
    this.addDimensionControl('fri', 'friFixed', 'COMPANY.SETTINGS_RAINDANCE_FIELDS.FRI', this.dataContext.fri, this.dataContext.friFixed);
    this.addDimensionControl('motp', 'motpFixed', 'COMPANY.SETTINGS_RAINDANCE_FIELDS.MOTP', this.dataContext.motp, this.dataContext.motpFixed);
    this.addDimensionControl(
      'periodisering',
      'periodiseringFixed',
      'COMPANY.SETTINGS_RAINDANCE_FIELDS.PERIODISERING',
      this.dataContext.periodisering,
      this.dataContext.periodiseringFixed
    );
  }

  private addDimensionControl(name: string, fixedName: string, caption: string, value: number, fixedValue: string): void {
    this.form.addControl(name, this._cf.create(caption, value));
    this.form.addControl(fixedName, this._cf.create(caption, fixedValue));
  }
}
